import { IAccountImpact } from 'src/types'
import ArrowIcon from 'src/assets/icons/arrow.icon'
import ArrowIconLeft from 'src/assets/icons/arrow.icon-left'
import { useMemo, useRef } from 'react'
import { useIsTablet } from 'src/hooks'
import { AccountImpactsList } from './account-impacts-list'
import { AccountImpactsWrapper, StyledScrollBtn } from './account-impacts.styled'

interface IProps {
  impacts: IAccountImpact[]
  walletAddress?: string
  showWalletAddress: boolean
  showBcInfo: boolean
  accountImage?: string
  primaryColor?: string | null
  alternativeColor?: string | null
}

export const AccountImpacts = ({
  impacts,
  walletAddress,
  showWalletAddress,
  showBcInfo,
  accountImage,
  primaryColor,
  alternativeColor,
}: IProps) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const isTablet = useIsTablet()

  const bannerStroke = useMemo(
    () => alternativeColor || primaryColor || '#1FA67A',
    [alternativeColor, primaryColor],
  )

  const scrollLeft = () => {
    if (scrollContainerRef?.current) {
      scrollContainerRef.current.scrollLeft += -130
    }
  }
  const scrollRight = () => {
    if (scrollContainerRef?.current) {
      scrollContainerRef.current.scrollLeft += 130
    }
  }

  const showArrows = !(isTablet || impacts.length < 6)

  return (
    <AccountImpactsWrapper id="index__components-account-impacts__accountimpactswrapper__l28">
      <StyledScrollBtn
        id="index__components-account-impacts__styledscrollbtn__l29"
        onClick={scrollLeft}
        style={{ display: showArrows ? '' : 'none' }}
      >
        <ArrowIconLeft />
      </StyledScrollBtn>
      {impacts.length > 0 && (
        <AccountImpactsList
          items={impacts}
          ref={scrollContainerRef}
          withArrows={showArrows}
          walletAddress={walletAddress}
          showWalletAddress={showWalletAddress}
          showBcInfo={showBcInfo}
          accountImage={accountImage}
          bannerStroke={bannerStroke}
        />
      )}
      <StyledScrollBtn
        id="index__components-account-impacts__styledscrollbtn__l42"
        onClick={scrollRight}
        style={{ display: showArrows ? '' : 'none' }}
      >
        <ArrowIcon />
      </StyledScrollBtn>
    </AccountImpactsWrapper>
  )
}
